import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { FaUmbrellaBeach } from '@react-icons/all-files/fa/FaUmbrellaBeach';
import { FaStar } from '@react-icons/all-files/fa/FaStar';
import { FaCalendarDay } from '@react-icons/all-files/fa/FaCalendarDay';
import { FaTable } from '@react-icons/all-files/fa/FaTable';
import { FaCalendarAlt } from '@react-icons/all-files/fa/FaCalendarAlt';
import { FaCog } from '@react-icons/all-files/fa/FaCog';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import Breadcrumb from '../../../../commons/Breadcrumb';
import TileContainer, { TileItem } from '../../../../commons/TileContainer';

const tiles: TileItem[] = [
  { key: 'dias-festivos',             label: 'Días Festivos',             icon: <FaStar />,        color: '#f59e0b' },
  { key: 'calendario-festivos',       label: 'Calendario de Festivos',    icon: <FaCalendarDay />, color: '#ef4444' },
  { key: 'tabla-dias-festivos',       label: 'Tabla de Días Festivos',    icon: <FaTable />,       color: '#8b5cf6' },
];

function FeriadosIndex() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <Breadcrumb items={[
        { label: 'Inicio',        to: '/',                         icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion',            icon: <FaCog /> },
        { label: 'Calendario',    to: '/configuracion/calendario', icon: <FaCalendarAlt /> },
        { label: 'Feriados',                                       icon: <FaUmbrellaBeach /> },
      ]} />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: '#f59e0b' }}>
          <FaUmbrellaBeach style={s.icon} />
        </div>
        <div>
          <h2 style={s.title}>Feriados</h2>
          <p style={s.subtitle}>Configuración de feriados</p>
        </div>
      </div>

      <TileContainer
        tiles={tiles}
        onSelect={key => navigate(`/configuracion/calendario/feriados/${key}`)}
      />
    </div>
  );
}

function SubPage({ tileKey }: { tileKey: string }) {
  const tile = tiles.find(t => t.key === tileKey)!;

  return (
    <div style={s.page}>
      <Breadcrumb items={[
        { label: 'Inicio',        to: '/',                                    icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion',                       icon: <FaCog /> },
        { label: 'Calendario',    to: '/configuracion/calendario',            icon: <FaCalendarAlt /> },
        { label: 'Feriados',      to: '/configuracion/calendario/feriados',   icon: <FaUmbrellaBeach /> },
        { label: tile.label,                                                  icon: tile.icon },
      ]} />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: tile.color }}>
          <span style={s.icon}>{tile.icon}</span>
        </div>
        <div>
          <h2 style={s.title}>{tile.label}</h2>
          <p style={s.subtitle}>Configuración de {tile.label.toLowerCase()}</p>
        </div>
      </div>

      <div style={s.placeholder}>
        <span style={{ fontSize: 32, color: '#cbd5e1' }}>{tile.icon}</span>
        <p style={{ margin: 0, color: '#94a3b8', fontSize: 14 }}>
          Configuración de <strong>{tile.label}</strong>
        </p>
      </div>
    </div>
  );
}

export default function FeriadosPage() {
  return (
    <Routes>
      <Route path="/"                      element={<FeriadosIndex />} />
      <Route path="/dias-festivos"         element={<SubPage tileKey="dias-festivos" />} />
      <Route path="/calendario-festivos"   element={<SubPage tileKey="calendario-festivos" />} />
      <Route path="/tabla-dias-festivos"   element={<SubPage tileKey="tabla-dias-festivos" />} />
    </Routes>
  );
}

const s: Record<string, React.CSSProperties> = {
  page:        { display: 'flex', flexDirection: 'column', gap: 28 },
  header:      { display: 'flex', alignItems: 'center', gap: 14 },
  iconBox:     { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  icon:        { fontSize: 22, color: '#fff', display: 'flex' },
  title:       { margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' },
  subtitle:    { margin: 0, fontSize: 13, color: '#64748b' },
  placeholder: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, padding: '48px 24px', background: '#fff', border: '1px dashed #e2e8f0', borderRadius: 12 },
};
